/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { 
  IconButton, 
  Box,
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const VideoPlayer = ({ url }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [imageUrlSrc, setImageUrlSrc] = useState('');
  const [hasError, setHasError] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = () => {
    setIsPlaying(true);
    videoRef.current.play();
    setTimeout(() => {
      videoRef.current.play();
    }, 100);
  };

  const captureImageFromVideo = (videoUrl, time) => new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = videoUrl;
    video.crossOrigin = 'anonymous';
    video.currentTime = time;

    video.addEventListener('loadeddata', () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext('2d');
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const imageUrl = canvas.toDataURL('image/png');
      resolve(imageUrl);
    });

    video.addEventListener('error', (err) => {
      reject(err);
    });

    video.load();
  });

  useEffect(() => {
    captureImageFromVideo(url, 2)
      .then((imageUrl) => {
        setImageUrlSrc(imageUrl)
      })
      .catch((error) => {
        console.error('Error capturing image:', error);
      });
  }, [url]);

  const getMimeType = (videoUrl) => {
    const ext = videoUrl.split('.').pop().toLowerCase();
    const mimeMap = {
      mp4: 'video/mp4',
      webm: 'video/webm',
      ogg: 'video/ogg',
      mov: 'video/quicktime',
    };
    return mimeMap[ext] || 'video/mp4';
  };


  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: 'black',
        borderRadius: '10px',
        overflow: 'hidden',
        width: '100%',
        minHeight: '200px',
        maxHeight: '500px',
        cursor: 'pointer',
        backgroundImage: imageUrlSrc ? `url(${imageUrlSrc})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        aspectRatio: '16/9',
      }}
    >
      <video
        ref={videoRef}
        controls={isPlaying}
        onError={() => setHasError(true)}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          display: isPlaying ? 'block' : 'none',
        }}
      >
        <source src={url} type={getMimeType(url)} />
        Your browser does not support the video tag.
      </video>
      {!isPlaying && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 10,
            }}
          >
            {hasError ? (
              <Box sx={{ p: 2, color: 'white', textAlign: 'center' }}>
                This video format may not play correctly in your browser.<br />
                <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#F35251' }}>
                  Open in new tab
                </a>
              </Box>
            ) : (
              <IconButton
                onClick={handlePlay}
                sx={{
                  backgroundColor: '#F35251',
                  border: '1px solid #F35251',
                  padding: '20px',
                  borderRadius: '50%',
                  '&:hover': {
                    backgroundColor: '#D03E3A',
                    border: '1px solid #D03E3A',
                  },
                }}
              >
                <PlayArrowIcon sx={{ color: 'white', fontSize: 50 }} />
              </IconButton>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

VideoPlayer.propTypes = {
  url: PropTypes.string.isRequired,
};


export default VideoPlayer;
